import { render, staticRenderFns } from "./InquiryFileViewer.vue?vue&type=template&id=9155c9fe&scoped=true&"
import script from "./InquiryFileViewer.vue?vue&type=script&lang=ts&"
export * from "./InquiryFileViewer.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryFileViewer.vue?vue&type=style&index=0&id=9155c9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9155c9fe",
  null
  
)

export default component.exports